import ButtonBack from "@/view/components/ButtonBack";
import useC6BankOffers from "./useC6BankOffers";
import { Spinner } from "@/view/components/ui/spinner";
import { Input } from "@/view/components/ui/input";
import OfferDetails from "./components/OfferDetails";
import { Dialog } from "@/view/components/ui/dialog";
import MakeProposalCard from "./components/MakeProposalCard";
import NewC6BankModal from "./components/NewC6BankModal";
import masks from "@/app/utils/masks";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/view/components/ui/select";

export default function C6BankOffers() {
  const {
    loading,
    loadingOffers,
    error,
    offers,
    currentIndex,
    setCurrentIndex,
    commission,
    debouncedFetch,
    handleConfirm,
    netAmountValue,
    installmentInput,
    setInstallmentInput,
    installmentOptions,
    selectedInstallment,
    handleSelectInstallment,
  } = useC6BankOffers();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <ButtonBack label="Opções de crédito" />

        <div className="flex h-[50vh] flex-col items-center justify-center gap-1">
          <span className="font-semibold text-black01">
            Não foi possível carregar as simulações
          </span>
          <span className="text-black03">{error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <ButtonBack label="Opções de crédito" />

      <div className="w-[30%] rounded-2xl border bg-white p-5">
        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium">
            Valor Liberado
          </label>

          <Input value={netAmountValue} disabled />
        </div>

        <div className="mb-4 flex items-end gap-4">
          <div className="flex-1">
            <label className="mb-2 block text-sm font-medium">
              Valor da parcela
            </label>

            <Input
              value={installmentInput}
              maxLength={12}
              onChange={(e) => {
                const raw = masks.number(e.target.value);

                if (!raw) {
                  setInstallmentInput("");
                  debouncedFetch.cancel();
                  return;
                }

                const formatted = masks.currency(raw);

                setInstallmentInput(formatted);

                debouncedFetch(Number(raw) / 100, selectedInstallment);
              }}
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium">Parcelas</label>

            <Select
              value={selectedInstallment ? String(selectedInstallment) : ""}
              onValueChange={(value) => handleSelectInstallment(Number(value))}
              disabled={!installmentOptions.length}
            >
              <SelectTrigger className="w-28">
                <SelectValue placeholder="Selecione" />
              </SelectTrigger>

              <SelectContent>
                {installmentOptions.map((installment) => (
                  <SelectItem key={installment} value={installment.toString()}>
                    {installment}x
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <Dialog>
          <MakeProposalCard
            disabled={loadingOffers}
            onSubmitProposal={handleConfirm}
          />
          <NewC6BankModal />
        </Dialog>
      </div>

      {loadingOffers && (
        <div className="flex justify-center pt-10">
          <Spinner />
        </div>
      )}

      {!loadingOffers && (
        <div className="flex gap-4 overflow-x-auto p-2">
          {offers.map((offer, index) => {
            const condicao = offer.condicao;

            const selected = currentIndex === index;

            return (
              <div
                key={condicao.id_simulacao}
                onClick={() => setCurrentIndex(index)}
                className={`
                    min-w-[340px]
                    cursor-pointer
                    rounded-2xl
                    border
                    p-5
                    transition-all
                    ${selected ? "border-primary" : "border-gray-200"}
                  `}
              >
                <div className="mb-4 flex items-center justify-between">
                  <div>
                    <h2 className="text-lg font-semibold">
                      {condicao.produto?.descricao}
                    </h2>
                    <p className="text-sm text-gray-500">
                      Convênio: {condicao.convenio?.descricao}
                    </p>
                  </div>
                  <div className="rounded-full bg-primary px-3 py-1 text-xs font-semibold text-white">
                    {condicao.quantidade_parcelas}x
                  </div>
                </div>

                <OfferDetails condicao={condicao} commission={commission} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
